import { UserRowData, ValidatedResult } from '@api/bulk-onboarding-import';
import { USER_ROLE_LABEL_MAP } from '@constants/user';
import { ColumnDef } from '@tanstack/react-table';
import { Table } from '../../../molecules/table/Table';
import { BasicAlert } from '../../../components/alert/BasicAlert';

export interface ReviewDataProps extends ValidatedResult {
  validRowCount: number;
  userLimit: number;
}

export const ReviewData = (props: ReviewDataProps) => {
  const { validatedData, validRowCount, userLimit, isUserLimitExceeded } = props;

  const columns: ColumnDef<UserRowData>[] = [
    {
      accessorKey: 'email',
      header: () => 'Email address',
    },
    {
      accessorKey: 'initiativeName',
      header: () => 'Subsidiary',
    },
    {
      accessorKey: 'permissions',
      header: () => 'Permissions',
      cell: ({ row }) => {
        return <span>{row.original.permissions.map((p) => USER_ROLE_LABEL_MAP[p]).join(', ')}</span>;
      },
    },
    {
      accessorKey: 'message',
      header: () => 'Error',
    },
  ];

  return (
    <div>
      <BasicAlert type='warning' hide={!isUserLimitExceeded}>
        You have reached your user limit of {userLimit}. Please contact us to increase your limit.
      </BasicAlert>
      <p>{validRowCount} users to invite</p>
      <Table columns={columns} data={validatedData} pageSize={10} />
    </div>
  );
};
